export default __webpack_public_path__ + "left_arrow.98b04142.svg";